const config = {
    appurl : "/"
}

export default config